<template>
  <div class="PLANREFUND">
    <div class="header">
      <span>*</span>
      <Input type="textarea"
             :rows="4"
             v-model="textarea"
             placeholder="请输入驳回意见" />
    </div>
    <div class="foot">
      <Button class="cancel-btn"
              @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error"
              class="sav-btn"
              @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ChineseDictionary from '@/assets/js/ChineseDictionary';
export default {
  data() {
    return {
      chineseName: '',
      textarea: '',
      tableName: "",
      itemId: ''
    }
  },
  created() {
    console.log(this);
    const { tableName, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.itemId = itemId;
    this.chineseName = ChineseDictionary;
  },

  methods: {
    cancel() {
      this.$emit('closeActionDialog', false); // 关闭弹框
    }, // 取消
    save() {
      if (!this.textarea) {
        this.$Message.warning('驳回意见不能为空!');
        return
      } else {
        let obj = {};
        obj['objid'] = this.itemId;
        obj['tableName'] = this.tableName;
        obj['description'] = this.textarea;
        axios({
          url: '/p/cs/planRefund',
          method: 'post',
          data: obj
        }).then(res => {
          if (res.data.data.code == 0) {
            this.$Message.success(res.data.data.message);
            this.$emit('closeActionDialog', false);
            document.querySelector('#refresh').click()
          } else {
            this.$emit('closeActionDialog', false);
            this.$Modal.fcError({
              title: '错误',
              content: res.data.data.message
            });
          }
        })
      }

    }
  }

}
</script>

<style lang='less' scoped>
.PLANREFUND {
  .header {
    display: flex;
    span {
      color: red;
      margin: 5px;
      font-size: 18px;
    }
  }
  .foot {
    display: flex;
    margin-top: 5px;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>